export const USER_TYPE = {
  TELCO: 'Telco',
  OPEN: '',
};

export const MOBILE_INSURANCE = {
  NS_OPTION: 'NS',
  TITLE: 'Añade seguro. ¡No te la juegues!',
  INFOBAR_LABEL: 'Elige la cobertura que más se adapte a ti.',
};

export const SE_PAYMENT_MODALITY = {
  CARD: 'Terminal libre Tarjeta',
  FUNDED: 'Terminal libre Financiado',
  DIRECT_DEBIT: 'Domiciliación bancaria',
};

export const CONTACT_MEDIUM_TYPE = {
  TEL: '1',
  SMS: '2',
  MAIL: '4',
};

export const DOC_TYPE_CODE = {
  DNI: 1,
  CIF: 2,
  NIE: 3,
  PASSPORT: 4,
};